/* eslint-disable no-useless-escape */
import {
    META_INDEX_FOLLOW, META_NOIDEX_NOFOLLOW, PAGE_TYPE_CATEGORY, PAGE_TYPE_PRODUCT
} from 'Component/Meta/Meta.config';
import { STOCK_TYPE } from 'Component/Product/Stock.config';
import {
    MetaDispatcher as SourceMetaDispatcher
} from 'SourceStore/Meta/Meta.dispatcher';
import { updateMeta } from 'Store/Meta/Meta.action';
import history from 'Util/History';
/** @namespace Bodypwa/Store/Meta/Dispatcher */
export class MetaDispatcher extends SourceMetaDispatcher {
    _getMetaRobots() {
        return history.location.search ? META_NOIDEX_NOFOLLOW : META_INDEX_FOLLOW;
    }

    /**
     * Get meta for product
     * @param {Object} product
     * @return {Object} Meta object
     * @memberof MetaDispatcher
     */
    _getProductMeta(product) {
        const {
            name,
            meta_title,
            meta_robots = this._getMetaRobots(),
            meta_keyword,
            description: {
                html: description
            } = {},
            image: {
                url: image
            } = {},
            price_range: {
                minimum_price: {
                    final_price: {
                        value: price,
                        currency: priceCurrency
                    } = {}
                } = {}
            } = {},
            canonical_url,
            meta_description,
            url,
            mw_hreflangs: { items } = {},
            mw_seo_markup,
            mv_seo_markup: {
                rich_snippets = {}
            } = {},
            stock_status,
            sku
        } = product;

        const richSnippetContent = {
            '@context': 'http:\/\/schema.org',
            '@type': 'Product',
            name,
            description: description || '',
            image: image || '',
            offers: {
                '@type': 'http:\/\/schema.org\/Offer',
                lowPrice: `${price}`,
                url: url && url[0] === '/' ? url?.substring(1) || '' : url || '',
                priceCurrency,
                availability: stock_status === STOCK_TYPE.IN_STOCK
                    ? 'http:\/\/schema.org\/InStock' : 'http:\/\/schema.org\/OutOfStock'
            },
            productID: sku,
            sku
        };

        // eslint-disable-next-line max-len
        const richSnippetProduct = `<script type=\"application/ld+json\">${JSON.stringify(richSnippetContent)}</script>`;

        return {
            description: meta_description,
            keywords: meta_keyword,
            title: meta_title || name,
            canonical_url: `${canonical_url || window.location.pathname}`,
            robots: meta_robots || this._getMetaRobots(),
            hreflangs: items,
            page_type: PAGE_TYPE_PRODUCT,
            mw_seo_markup: {
                ...mw_seo_markup,
                rich_snippets: {
                    ...rich_snippets,
                    product: richSnippetProduct
                }
            }
        };
    }

    /**
     * Get meta for category
     * @param {Object} category
     * @return {Object} Meta object
     * @memberof MetaDispatcher
     */
    _getCategoryMeta(category) {
        const {
            description, name, canonical_url,
            meta_title, meta_keywords, meta_description,
            meta_robots = this._getMetaRobots(),
            url,
            mw_hreflangs: { items } = {},
            mw_seo_markup
        } = category;

        return {
            description: meta_description || description,
            title: meta_title || name,
            keywords: meta_keywords,
            canonical_url: `${canonical_url || url}`,
            robots: meta_robots || this._getMetaRobots(),
            hreflangs: items,
            page_type: PAGE_TYPE_CATEGORY,
            mw_seo_markup
        };
    }

    /**
     * Set meta for product
     * @param {Object} product
     * @param {Function} dispatch
     * @memberof MetaDispatcher
     */
    updateWithProduct(product, dispatch) {
        const meta = this._getProductMeta(product);
        dispatch(updateMeta(meta));
    }
}

export default new MetaDispatcher();
